import { createFileRoute } from '@tanstack/react-router';

import { LineItemEditorPage } from '../features/campaigns/campaigns/components/LineItemEditor/LineItemEditorPage';

export const Route = createFileRoute(
  '/campaigns/campaigns_/overview/$campaignId_/line-items/create',
)({
  component: CreateLineItemRoute,
});

function CreateLineItemRoute() {
  const { campaignId } = Route.useParams();
  return <LineItemEditorPage campaignId={campaignId} />;
}
